export default __webpack_public_path__ + "static/media/ONBOARD_LOGO_BLACK_HORIZONTAL.dc62d12a.svg";